import React, { useEffect, useState } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./CommonBreadcrumb.css";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import { channelPartnerCount } from "../../../features/admin/common/Slice";

export default function CommonBreadcrumb({ items }) {
  const dispatch = useDispatch();

  const all_channel_partner_count = useSelector(
    (state) => state?.common?.all_channel_partner_count,
  );

  const location = useLocation();

  const [orderType, setOrderType] = useState("");

  useEffect(() => {
    setOrderType(sessionStorage.getItem("orderType") || "");
  }, [location.pathname]);

  useEffect(() => {
    dispatch(channelPartnerCount());
  }, [dispatch]);
  return (
    <div className="breadcrumb-wrapper">
      <Container className="br-wrapper">
        <Breadcrumb>
          {items.map((item, index) => (
            <Breadcrumb.Item
              key={index}
              linkAs={item.link ? Link : undefined}
              linkProps={item.link ? { to: item.link } : undefined}
              active={!item.link}
            >
              {item.label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        {/* {location.pathname === "/cart" && orderType === "shareholder" && (
          <div className="live_counter">
            <div className="dot"></div>

            <div className="counter_content">
              <h4>
                <span>NO OF CHANNEL PARTNERS </span>{" "}
                <CountUp
                  start={0}
                  end={all_channel_partner_count}
                  duration={3}
                  separator=","
                />{" "}
              </h4>

              <p></p>
            </div>
          </div>
        )} */}
      </Container>
    </div>
  );
}
